import { render, staticRenderFns } from "./ManageCampaignsTag.vue?vue&type=template&id=7c4a06ad&lang=html&"
import script from "./ManageCampaignsTag.vue?vue&type=script&lang=js&"
export * from "./ManageCampaignsTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports